import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { cloneDeep, includes, isEmpty, map, size, capitalize } from "lodash";
import Emitter from "../../utils/Emitter";

import { getCountryList, getHSCodeList, getHScodeSuggetions, getServicesList, searchPortData } from "../../actions/defaultDataAction";
import { getBuyerSupplierList } from "../../actions/memberAction";

import { default as ReactSelect, components } from "react-select";
import { WithContext as ReactTags } from "react-tag-input";
import { istTODate } from '../../utils/common';
import DropDown from "../DropDown";
import Button from "../Button";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { showLoading, hideLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";
import ToolipsCustom from "../ToolipsCustom";
import InputField from "../../components/InputField";
import DatePickerField from '../../components/DatePickerField';
import { getSubscriptionPlanList } from '../../actions/subscriptionPlanAction';
import DateRangeFilterPicker from '../DateRangeFilterPicker';
import { format } from 'date-fns';

const PaidMemberFilter = (props) => {

    const { user } = useAuth();
    const { admin } = defaultValues;

    const [searchedTxt, setSearchedTxt] = useState(null);
    const [planList, setPlanList] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState("");

    const [offset0, setOffset0] = useState(admin.OFFSET);
    const [limit0, setLimit0] = useState(admin.LIMIT);

    const [searchTxt0, setSearchTxt0] = useState("");

    const [tradeModeType, setTradeModeType] = useState(null);

    const [dateRange, setDateRange] = useState(null);

    const [plan_start_date, setPlanStartDate] = useState(null);
    const [plan_end_date, setPlanEndDate] = useState(null);
    const today = new Date();
    const filterTypeOptions = [
        {
            label: 'Trade Mode',
            value: 'trade_mode'
        }, {
            label: 'Buyer/Supplier',
            value: 'buyerOrSupplier'
        }, {
            label: 'Logistic Partner',
            value: 'LOG_PTR'
        }
    ];

    const [filterTypeOptionVal, setFilterOptionVal] = useState(filterTypeOptions[0]);

    const filterPlanTypeOptions = [
        {
            label: 'Plan Start Date',
            value: 'start_date'
        }, {
            label: 'Plan Expired Date',
            value: 'end_date'
        }
    ];

    const [filterPlanTypeOptionVal, setFilterPlanOptionVal] = useState(filterPlanTypeOptions[0]);

    const handleFilterTypeChange = async (val) => {

        setTradeModeType(null);
        setFilterOptionVal(val);
        setPlanList([]);
        setSelectedPlan("");
        // setPlanStartDate(null);
        // setPlanEndDate(null);
        if (val.value == 'trade_mode') {
            return;
        } else {
            getPlans(offset0, limit0, val.value);
            setTradeModeType(val);
            setFilterOptionVal(val);
        }

    }

     const handleFilterPlanTypeChange = async (val) => {
        setFilterPlanOptionVal(val);
    }


    const filterMembers = () => {
        let startDate = null;
        let endDate = null;
        if (plan_start_date) {
            startDate = plan_start_date;
        }
        if (plan_end_date) {
            endDate = plan_end_date;
        }

        const filterObj = {
            filterBy: filterTypeOptionVal?.value ?? '',
            filter_type: filterPlanTypeOptionVal?.value ?? '',
            filter_val: '',
            plan_id: selectedPlan?.value ?? null,
            start_date: startDate,
            end_date: endDate,
            limit: admin.LIMIT,
            offset: admin.OFFSET
        };

        Emitter.emit("SET_FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);
    };


    const resetFilter = () => {
        setTradeModeType(null);
        setFilterOptionVal(null);
        setFilterPlanOptionVal(null);
        setPlanList([]);
        setSelectedPlan(null);
        setDateRange(null);
        setPlanStartDate(null);
        setPlanEndDate(null);


        const clearAllButton = document.getElementsByClassName("ReactTags__clearAll");
        if (clearAllButton.length > 0) {
            clearAllButton[0].click();
        } else {
            const searchInput = document.getElementsByClassName("search_input")[0];
            if (searchInput) {
                searchInput.value = "";
            }
        }

        const filterObj = {
            filterBy: filterTypeOptions[0].value,
            filter_type: filterPlanTypeOptions[0].value,
            filter_val: "",
            plan_id: "",
            start_date: "",
            end_date: "",
            table_search: "",
            sortDirection: "DESC",
            columnName: "id",
            limit: admin.LIMIT,
            offset: admin.OFFSET
        };
        setFilterPlanOptionVal(filterPlanTypeOptions[0]);
        setFilterOptionVal(filterTypeOptions[0]);
        setTradeModeType(null);
        Emitter.emit("SET_FILTER_MEMBERS", filterObj);
        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);
    };


    const handlePlanInputChange = (val, actionMeta) => {

        if (tradeModeType === null || tradeModeType === '') {
            return;
        } else {

            const { prevInputValue } = actionMeta;
            if (size(val) > 3) {
                getPlans(0, 20, tradeModeType.value, val);
            } else if (size(val) === 0 && (prevInputValue !== val)) {
                getPlans(0, 20, tradeModeType.value, "");
            }
        }
    }

    const getPlans = async (offset0, limit0, type, searchTxt0 = "") => {
        await props.getSubscriptionPlans(offset0, limit0, "created_at", "DESC", type, searchTxt0).then((response) => {
            if (response.status === true) {
                let pList = response.data.map((val) => {
                    return {
                        label: val.name,
                        value: val.id
                    }
                });
                let newPLList = [...pList];
                setPlanList(newPLList);
            }
        }).catch((err) => {
            console.log("Error ==== ", err);
        })
    }

    const handlePlanChange = (val) => {
        setSelectedPlan(val);
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };

    const handleChange = (val) => {
        setDateRange(val);
        if (val) {
            const [fromDate, toDate] = val;

            const formattedFrom = format(fromDate, 'yyyy-MM-dd');
            const formattedTo = format(toDate, 'yyyy-MM-dd');
            setPlanStartDate(formattedFrom);
            setPlanEndDate(formattedTo);

        } else {
            setPlanStartDate("");
            setPlanEndDate("");
        }

    }
    const defaultCalendarValue = [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 1)
    ];

    return (

        <div className="bg-white shadow rounded p-4 mb-4">

            <div className="row paid-members-filter">

                <div className="col-xl-2 col-md-6 mt-2" >
                    <DropDown placeholder="Select.." options={filterTypeOptions} value={filterTypeOptionVal} menuPlacement='bottom' onChange={handleFilterTypeChange} />
                </div>

                <div className="col-xl-2 col-md-6 mt-2" >

                    <ReactSelect
                        options={planList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={handlePlanChange}
                        value={selectedPlan}
                        onInputChange={handlePlanInputChange}
                        styles={customStyles}
                        placeholder="Select Plan"
                        className="member-filter-container"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Plans Found"}
                        id="plan_id"
                        name="plan_id"
                    />


                </div>

                 <div className="col-xl-2 col-md-6 mt-2" >
                    <DropDown placeholder="Select.." options={filterPlanTypeOptions} value={filterPlanTypeOptionVal} menuPlacement='bottom' onChange={handleFilterPlanTypeChange} />
                </div>

                <div className="col-xl-3 col-md-6 mt-2 date-range" >
                    <DateRangeFilterPicker
                        value={dateRange}
                        onChange={handleChange}
                        defaultCalendarValue={defaultCalendarValue}
                    />
                </div>



                <div className="filter-search-btn col-xl-3 col-lg-12 d-flex align-items-center mt-2 search">
                    <ButtonAdminpanel type="button" onClick={filterMembers} className="btn-regi">  <i className="fa-solid fa-magnifying-glass text-white"></i> Search </ButtonAdminpanel>

                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>

                </div>


            </div>

        </div>


    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSubscriptionPlans: (offset0, limit0, columnName0, sortDirection0, type, searchTxt0) =>
            dispatch(getSubscriptionPlanList(offset0, limit0, columnName0, sortDirection0, type, searchTxt0)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PaidMemberFilter));

